import { render, staticRenderFns } from "./AIHeader.vue?vue&type=template&id=b56701fc&scoped=true"
import script from "./AIHeader.vue?vue&type=script&lang=js"
export * from "./AIHeader.vue?vue&type=script&lang=js"
import style0 from "./AIHeader.vue?vue&type=style&index=0&id=b56701fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b56701fc",
  null
  
)

export default component.exports